// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"379":"504e7d71","404":"e511c871"}[chunkId] + ".chunk.js";
};